<header id="page-topbar" (window:scroll)="windowScroll()">
    <div class="layout-width border-top-0 border-start-0 border-end-0 border ">
        <div class="navbar-header ">
            <div class="d-flex gap-2" style="align-items: center">

                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a routerLink="" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/myfile/Favicon-Black-Noborder-Transparent.png" alt="" height="30">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/myfile/MyFileName-Black-Transparent.png" alt="" height="50">
                        </span>
                    </a>

                    <a routerLink="" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="assets/myfile/Favicon-White-Noborder-Transparent.png" alt="" height="30">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/myfile/MyFileName-White-Transparent.png" alt="" height="50">
                        </span>
                    </a>
                </div>

                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                    id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon" [ngClass]="{ 'open': showArrow()}">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

                <!-- App Search-->
                <app-multisearch *ngIf="showSearchbar"></app-multisearch>
                <div *ngIf="isAIChatVisible" id="" class="dropdown topbar-head-chat-dropdown ms-1 header-item cursor-pointer">
                    <img (click)="openAIChat()" class="avatar-logo rounded-circle img-thumbnail transparentBackground "
                        src="/assets/images/ai/myfile-chat-icon.png">
                </div>

            </div>

            <div class="d-flex align-items-center ">

                <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false" ngbDropdownToggle>
                        <i class="bx bx-search fs-22"></i>
                    </button>
                    <div ngbDropdownMenu class="">
                        <div class="p-1">
                            <app-multisearch *ngIf="!showSearchbar"></app-multisearch>
                        </div>
                    </div>
                </div>

                <div class="dropdown ms-1 topbar-head-dropdown header-item" ngbDropdown>
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                        <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="20"
                            class="rounded">
                        <img *ngIf="flagvalue === undefined" src="{{valueset}}" alt="Header Language" height="20"
                            class="rounded">
                    </button>
                    <div class="dropdown-menu dropdown-menu-end  " ngbDropdownMenu>
                        <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" data-lang="eng"
                            *ngFor="let item of listLang" (click)="setLanguage(item.text, item.lang, item.flag)"
                            [ngClass]="{'active': this.pref.language === item.lang}">
                            <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18"> <span
                                class="align-middle">{{item.text}}</span>
                        </a>
                    </div>
                </div>

                <div *ngIf="loginType == LoginType.User"  class="dropdown topbar-head-dropdown ms-1 header-item " (openChange)="cartOpen($event)" ngbDropdown
                    (openChange)="querySelector('page-header-cart-dropdown')" #cartDropdown="ngbDropdown">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle "
                        id="page-header-cart-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false" ngbDropdownToggle openChange="cartOpen">
                        <i class='bx bx-shopping-bag fs-22'></i>
                        <span
                            class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-info">{{cart_length}}<span
                                class="visually-hidden">unread messages</span></span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-xl dropdown-menu-start p-0 " style="width: 450px;"
                        aria-labelledby="page-header-cart-dropdown " ngbDropdownMenu>
                        <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="m-0 fs-16 fw-semibold"> My Cart</h6>
                                </div>
                                <div class="col-auto">
                                    <span class="badge badge-soft-warning fs-13"> {{cart_length}} items</span>
                                </div>
                            </div>
                        </div>
                        <div style="max-height: 300px; overflow: scroll;" class="px-2">

                            <table class="table align-middle table-nowrap pb-0 mb-0"
                                style=" justify-content: space-around;">
                                <tbody class="list form-check-all" style="cursor:default">
                                    <tr *ngFor="let data of requisitionsCart" id="i_{{data.id}}"
                                        style="background-color: var(--vz-footer-bg); ">
                                        <td style="width: 0">
                                            <div class="d-flex align-items-center gap-2">
                                                <div class="flex-shrink-0">
                                                    <img src='{{data.img}}' class=" avatar-xs rounded-circle p-0 m-0">
                                                </div>
                                                <div>
                                                    <div *ngIf="data.number">
                                                        {{data.number}}
                                                    </div>
                                                    <p class="mb-0 fs-12 text-muted">
                                                        <span *ngIf="data.matterNumber"
                                                            i18n="@@Modal_Requisition_Body_MatNum">
                                                            Mat#</span>
                                                        <span *ngIf="data.matterNumber else elseNoMatter">
                                                            {{data.matterNumber}}
                                                        </span>
                                                        <ng-template #elseNoMatter>
                                                            <strong style="color: #ed5e5e;">No Matter</strong>
                                                        </ng-template>
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center">

                                                <div>
                                                    <div *ngIf="data.client else elseNoClient">
                                                        {{data.client.fullName}}
                                                    </div>

                                                    <ng-template #elseNoClient>
                                                        <strong style="color: #ed5e5e;">No Client</strong>
                                                    </ng-template>


                                                    <p class="mb-0 fs-12 text-muted">
                                                        <span *ngIf="data.account else elseNoAccountName">
                                                            {{data.account.fullName}}
                                                        </span>

                                                        <ng-template #elseNoAccountName>
                                                            <strong style="color: #ed5e5e;">No Contact</strong>
                                                        </ng-template>
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngIf="data.total" style="font-size: 1rem">
                                                {{data.total |currency}}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                        <div class="p-3 border-bottom-0 border-start-0 border-end-0 border-dashed border d-grid">
                            <div class="d-flex justify-content-between align-items-center pb-3">
                                <h5 class="m-0 text-muted">Total</h5>
                                <div class="px-2">
                                    <h5 class="m-0"><span>{{totalCost| currency}}</span></h5>
                                </div>
                            </div>

                            <button [disabled]="totalCost==0" (click)=cartDropdown.close()
                                routerLink="/ecommerce/checkout" class="btn btn-success text-center">
                                Checkout
                            </button>
                        </div>
                        <div *ngIf="isLoadingCartVal" id="elmLoader">
                            <div class="spinner-border text-primary avatar-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="ms-1 header-item d-none d-sm-flex">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        data-toggle="fullscreen" (click)="fullscreen()">
                        <i class='bx bx-fullscreen fs-22'></i>
                    </button>
                </div>

                <div class="ms-1 header-item d-none d-sm-flex">
                    <button type="button"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode">
                        <i class='bx bx-moon fs-22' (click)="changeMode('dark')"></i>
                        <i class='bx bx-sun fs-22' (click)="changeMode('light')"></i>
                    </button>
                </div>



                <div id="openDropDownWithNotifications" class="dropdown topbar-head-dropdown ms-1 header-item"
                    (openChange)="querySelector('page-header-notifications-dropdown')" ngbDropdown>
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false" ngbDropdownToggle>
                        <i class='bx bx-bell fs-22'></i>
                        <span
                            class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{{totalNewNotifications}}<span
                                class="visually-hidden">unread messages</span></span>
                    </button>

                    <div class="dropdown-menu dropdown-menu-start p-0 " style="width: 500px;"
                    
                        aria-labelledby="page-header-notifications-dropdown " ngbDropdownMenu>

                        <div class="dropdown-head bg-primary bg-pattern rounded-top">
                            <div class="p-3">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h6 class="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                                    </div>
                                    <div class="col-auto dropdown-tabs">
                                        <span class="badge text-body fs-13"
                                            style="background-color: var(--vz-body-bg) !important;">
                                            {{totalNewNotifications}} New</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="tab-content" id="notificationItemsTabContent" >
                            <div class="tab-content text-muted" >
                                <div style="z-index: 999999;">
                                    <app-notifications-list [notificationUpdate]="notificationUpdate"  
                                        [notificationType]=notificationType></app-notifications-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dropdown ms-sm-3 header-item topbar-user" (openChange)="querySelector('page-header-user-dropdown')"  ngbDropdown>
                    <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown"  
                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle >
                        <span class="d-flex align-items-center">
                            <img class="rounded-circle header-profile-user" [src]="profilePhotoPNGTransform()"
                                alt="Header Avatar">
                            <span class="text-start ms-xl-2 d-grid">

                                <span *ngIf="(userContext?.firstName || userContext?.lastName); else emailTemplate"
                                    class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{shortenText(userContext?.firstName)}}
                                    {{userContext?.lastName}}</span>

                                <ng-template #emailTemplate>
                                    <span
                                        class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{shortenText(userContext?.email)}}</span>
                                </ng-template>

                                <span
                                    class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{{shortenText(currentTenant.name)}}</span>
                            </span>
                        </span>
                    </button>



                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-start p-0 "
                        aria-labelledby="page-header-user-dropdown" ngbDropdownMenu>
                        <div>
                            <div class="tab-content" id="notificationItemsTabContent">
                                <div class="tab-content text-muted">
                                    <div style="z-index: 999999;">
                                        <h6 class="dropdown-header"><span i18n="@@Welcome">PLACEHOLDERTEXT</span>
                                            {{userContext?.email}}
                                        </h6>
                                        <a *ngIf="loginType == LoginType.User" class="dropdown-item"
                                            routerLink="/pages/profile"><i
                                                class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                                            <span class="align-middle"
                                                i18n="@@UserDropDown_Profile">PLACEHOLDERTEXT</span></a>
                                        <a class="dropdown-item" href="javascript:void(0);" (click)="logout()"><i
                                                class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                                class="align-middle" data-key="t-logout"
                                                i18n="@@UserDropDown_Logout">PLACEHOLDERTEXT</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>





                </div>

            </div>

        </div>
    </div>
</header>